import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/app/environments/environments.dev';

@Component({
  selector: 'app-dashboard-sync',
  templateUrl: './dashboard-sync.component.html',
  styleUrls: ['./dashboard-sync.component.css']
})
export class DashboardSyncComponent implements OnInit {
  records: any[] = [];
  isLoading = false;
  apiUrl = environment.apiUrl+'/data/sap-to-salesforce'; // Ajusta la URL del backend

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchData();
    setInterval(() => {
      this.fetchData();
    }, 60000); // Actualiza cada 60 segundos
  }

  fetchData(): void {
    this.isLoading = true;
    this.http.get<any[]>(this.apiUrl).subscribe(
      (data) => {
        this.records = data;
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching data:', error);
        this.isLoading = false;
      }
    );
  }
}
